module.exports = "https://www.gc-pro.gnp.com.mx/57e7bfe70541bea66e8b971ba74677e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/videos/actualizacion/2.png
// module id = 1002
// module chunks = 0 1